import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const salespeople = [
  { rank: 1, name: 'Jose Reyes', region: 'NCR', revenue: '₱5.2M', attainment: 118, orders: 342, accounts: 87, trend: 'up', score: 94 },
  { rank: 2, name: 'Maria Cruz', region: 'Cebu', revenue: '₱4.8M', attainment: 112, orders: 318, accounts: 79, trend: 'up', score: 91 },
  { rank: 3, name: 'Pedro Santos', region: 'Luzon S', revenue: '₱4.5M', attainment: 108, orders: 295, accounts: 82, trend: 'up', score: 88 },
  { rank: 4, name: 'Ana Dela Cruz', region: 'Davao', revenue: '₱4.1M', attainment: 97, orders: 271, accounts: 74, trend: 'down', score: 82 },
  { rank: 5, name: 'Ramon Bautista', region: 'Visayas', revenue: '₱3.8M', attainment: 91, orders: 248, accounts: 68, trend: 'down', score: 78 },
  { rank: 6, name: 'Liza Gonzales', region: 'NCR', revenue: '₱3.5M', attainment: 84, orders: 231, accounts: 63, trend: 'up', score: 75 },
  { rank: 7, name: 'Carlo Mendoza', region: 'Luzon N', revenue: '₱3.1M', attainment: 74, orders: 198, accounts: 55, trend: 'down', score: 61 },
  { rank: 8, name: 'Rosa Villanueva', region: 'Mindanao', revenue: '₱2.8M', attainment: 67, orders: 176, accounts: 48, trend: 'down', score: 54 },
];

const scoreColor = (s) => s >= 90 ? 'text-success' : s >= 75 ? 'text-warning' : 'text-destructive';
const scoreBg = (s) => s >= 90 ? 'bg-success' : s >= 75 ? 'bg-warning' : 'bg-destructive';

export default function SalespersonRankingTable() {
  const [sortField, setSortField] = useState('rank');

  return (
    <div className="card p-4 md:p-5 lg:p-6 table-panel-depth">
      <div className="flex items-center justify-between mb-3 md:mb-4 flex-wrap gap-2">
        <div>
          <h3 className="font-heading font-semibold text-base md:text-lg lg:text-xl" style={{ color: '#0F172A', letterSpacing: '0.01em' }}>Salesperson Productivity Ranking</h3>
          <p className="font-caption text-xs sm:text-sm mt-0.5" style={{ color: '#475569' }}>Performance scores based on attainment, orders & coverage</p>
        </div>
      </div>

      {/* Desktop & Tablet: scrollable table */}
      <div className="hidden sm:block overflow-x-auto custom-scrollbar">
        <table className="w-full min-w-[600px]">
          <thead>
            <tr className="border-b border-border">
              {['Rank', 'Name', 'Region', 'Revenue', 'Attainment', 'Orders', 'Accounts', 'Trend', 'Score']?.map((h) => (
                <th key={h} className="text-left py-2 px-2 md:px-3 font-caption text-xs font-semibold uppercase tracking-wider whitespace-nowrap" style={{ color: '#374151' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {salespeople?.map((sp) => (
              <tr key={sp?.rank} className="border-b border-border table-row-glow transition-smooth-fast">
                <td className="py-2 md:py-3 px-2 md:px-3 sticky left-0 bg-card z-10">
                  <span className={`font-data text-xs md:text-sm font-bold ${sp?.rank <= 3 ? 'text-accent' : ''}`} style={sp?.rank > 3 ? { color: '#475569' } : {}}>
                    #{sp?.rank}
                  </span>
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3 font-caption text-xs md:text-sm font-semibold whitespace-nowrap" style={{ color: '#1E293B' }}>{sp?.name}</td>
                <td className="py-2 md:py-3 px-2 md:px-3 font-caption text-xs md:text-sm" style={{ color: '#475569' }}>{sp?.region}</td>
                <td className="py-2 md:py-3 px-2 md:px-3 font-data text-xs md:text-sm font-semibold whitespace-nowrap" style={{ color: '#0F172A' }}>{sp?.revenue}</td>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <span className={`font-data text-xs md:text-sm font-semibold ${sp?.attainment >= 100 ? 'text-success' : sp?.attainment >= 80 ? 'text-warning' : 'text-destructive'}`}>
                    {sp?.attainment}%
                  </span>
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3 font-data text-xs md:text-sm" style={{ color: '#1E293B' }}>{sp?.orders}</td>
                <td className="py-2 md:py-3 px-2 md:px-3 font-data text-xs md:text-sm" style={{ color: '#1E293B' }}>{sp?.accounts}</td>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <Icon name={sp?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={15} color={sp?.trend === 'up' ? 'var(--color-success)' : 'var(--color-destructive)'} strokeWidth={2.5} />
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <div className="flex items-center gap-1.5">
                    <div className="w-12 md:w-16 h-1.5 bg-muted rounded-full overflow-hidden">
                      <div className={`h-full rounded-full ${scoreBg(sp?.score)}`} style={{ width: `${sp?.score}%` }} />
                    </div>
                    <span className={`font-data text-xs font-bold ${scoreColor(sp?.score)}`}>{sp?.score}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile: card-stacked layout */}
      <div className="sm:hidden space-y-2">
        {salespeople?.map((sp) => (
          <div key={sp?.rank} className="border border-border rounded-lg p-3 bg-card">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="flex items-center gap-2">
                <span className={`font-data text-sm font-bold ${sp?.rank <= 3 ? 'text-accent' : ''}`} style={sp?.rank > 3 ? { color: '#475569' } : {}}>#{sp?.rank}</span>
                <div>
                  <p className="font-caption text-sm font-semibold" style={{ color: '#1E293B' }}>{sp?.name}</p>
                  <p className="font-caption text-xs" style={{ color: '#475569' }}>{sp?.region}</p>
                </div>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-12 h-1.5 bg-muted rounded-full overflow-hidden">
                  <div className={`h-full rounded-full ${scoreBg(sp?.score)}`} style={{ width: `${sp?.score}%` }} />
                </div>
                <span className={`font-data text-xs font-bold ${scoreColor(sp?.score)}`}>{sp?.score}</span>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-x-3 gap-y-1.5">
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Revenue</p>
                <p className="font-data text-xs font-bold" style={{ color: '#0F172A' }}>{sp?.revenue}</p>
              </div>
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Attainment</p>
                <span className={`font-data text-xs font-semibold ${sp?.attainment >= 100 ? 'text-success' : sp?.attainment >= 80 ? 'text-warning' : 'text-destructive'}`}>{sp?.attainment}%</span>
              </div>
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Orders</p>
                <p className="font-data text-xs" style={{ color: '#1E293B' }}>{sp?.orders}</p>
              </div>
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Accounts</p>
                <p className="font-data text-xs" style={{ color: '#1E293B' }}>{sp?.accounts}</p>
              </div>
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Trend</p>
                <Icon name={sp?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={14} color={sp?.trend === 'up' ? 'var(--color-success)' : 'var(--color-destructive)'} strokeWidth={2.5} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}